<div class="dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">View Agenda Item</h4>
        <button type="button" class="close-btn" (click)="onClose()" aria-label="Close dialog">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3 text-muted">Loading agenda item details...</p>
    </div>

    <!-- Dialog Content -->
    <div *ngIf="!isLoading && agendaItem" class="dialog-content">
        <!-- Subject of the Agenda -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Subject of the Agenda</h5>
            <textarea 
                class="form-control view-textarea" 
                rows="2"
                readonly
                [disabled]="true"
                [value]="getSubject()">
            </textarea>
        </div>

        <!-- Description -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Description</h5>
            
            <!-- Agenda Description (English) -->
            <div class="mb-3">
                <label class="form-label fw-bold mb-2">Agenda Description (English)</label>
                <textarea 
                    class="form-control view-textarea" 
                    rows="4"
                    readonly
                    [disabled]="true"
                    [value]="getDescriptionEN()">
                </textarea>
            </div>

            <!-- Agenda Description (Arabic) -->
            <div class="mb-3">
                <label class="form-label fw-bold mb-2">Agenda Description (Arabic)</label>
                <textarea 
                    class="form-control view-textarea" 
                    rows="4"
                    readonly
                    [disabled]="true"
                    [value]="getDescriptionAR()">
                </textarea>
            </div>
        </div>

        <!-- Required From TC -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Required From TC</h5>
            <textarea 
                class="form-control view-textarea" 
                rows="4"
                readonly
                [disabled]="true"
                [value]="getRequiredFromTC()">
            </textarea>
        </div>

        <!-- TC Notes -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">TC Notes</h5>
            <textarea 
                class="form-control view-textarea" 
                rows="4"
                readonly
                [disabled]="true"
                [value]="getTCNotes()">
            </textarea>
        </div>

        <!-- Attachments -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Attachments</h5>
            <div class="attachments-container" *ngIf="getAttachments().length > 0; else noAttachments">
                <div class="attachment-list">
                    <div *ngFor="let attachment of getAttachments(); let i = index" class="attachment-item">
                        <div class="attachment-info">
                            <i class="fas fa-file-alt attachment-icon"></i>
                            <span class="attachment-name">{{ attachment.fileName || attachment.name || 'Attachment ' + (i + 1) }}</span>
                            <span class="attachment-size" *ngIf="attachment.fileSize">
                                ({{ formatFileSize(attachment.fileSize) }})
                            </span>
                        </div>
                        <div class="attachment-actions">
                            <button 
                                type="button"
                                class="btn btn-sm btn-view"
                                (click)="viewAttachment(attachment)"
                                [title]="'View ' + (attachment.name || 'attachment')">
                                <i class="fas fa-eye me-1"></i> View
                            </button>
                            <button 
                                type="button"
                                class="btn btn-sm btn-download"
                                (click)="downloadAttachment(attachment)"
                                [title]="'Download ' + (attachment.name || 'attachment')">
                                <i class="fas fa-download me-1"></i> Download
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noAttachments>
                <div class="no-attachments-message">
                    <i class="fas fa-file-alt"></i>
                    <span>No attachments available</span>
                </div>
            </ng-template>
        </div>

        <!-- My Note -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">My Note</h5>
            <div *ngIf="isLoading" class="note-status text-muted mb-2">Loading note...</div>
            <textarea
                class="form-control note-textarea"
                rows="4"
                placeholder="Enter your note"
                [(ngModel)]="myNote"
                [ngModelOptions]="{ standalone: true }">
            </textarea>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && !agendaItem" class="error-container text-center py-5">
        <p class="text-danger">Failed to load agenda item details.</p>
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer d-flex justify-content-between align-items-center gap-2">
        <button type="button" class="btn close-btn-footer" (click)="onClose()">Close</button>
        
        <button
            type="button"
            class="btn save-btn-footer"
            (click)="saveMyNote()"
            [disabled]="isLoading || !agendaItem">
            {{ isLoading ? '...' : 'Save' }}
        </button>
    </div>
</div>
